<template>
  <div class="message" v-if="hasContent" :class="[isTriggered,isCollapsible]">
    <p class="text" v-for="paragraph in messageBody" :key="paragraph.id" v-html="paragraph.text"></p>
    <button class="link link--read-more" v-if="showExpandButton" @click="expanded = true">
      <lennoc-icon image="chevron-top" domClass="icon--circled"></lennoc-icon>
      <span>{{ opentext }}</span>
    </button>
    <button class="link link--read-more" v-if="expanded" @click="expanded = false">
      <lennoc-icon image="chevron-bottom" domClass="icon--circled"></lennoc-icon>
      <span>{{ closetext }}</span>
    </button>
  </div>
</template>

<script>
import bbob from '@bbob/html'
import presetHTML5 from '@bbob/preset-html5'

export default {
  name: 'BaseFlexMessage',
  props: {
    message: {
      type: String,
      required: true
    },
    max_length: {
      type: Number,
      default () {
        return 530
      }
    },
    folding: {
      type: Boolean,
      default () {
        return true
      }
    },
    opentext: {
      type: String,
      default () {
        return 'Lees meer'
      }
    },
    closetext: {
      type: String,
      default () {
        return 'Inklappen'
      }
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    parseOptions () {
      return {
        onlyAllowTags: ['url', 'p', 'ul', 'li'],
        onError: (err) => console.log(err.message, err.lineNumber, err.columnNumber)
      }
    },
    isTriggered () {
      return this.expanded ? 'messages__collapsible--triggered' : ''
    },
    isCollapsible () {
      return this.showExpandButton ? 'messages__collapsible' : ''
    },
    hasContent () {
      return this.messageBody.length > 0
    },
    showExpandButton () {
      return (
        this.shortText && !this.expanded
      )
    },
    shortText () {
      return this.message.length > this.max_length
        ? this.message.substr(0, this.max_length)
        : ''
    },
    messageBody () {
      const text = this.message
      return this.cleanSplit(text).map((p, index) => {
        const parsed = { id: `p_${index}`, text: bbob(p, presetHTML5()) }
        if (p.includes('[url')) {
          p = bbob(p, presetHTML5())
          const pos = p.search('href')
          const insertString = 'target="_blank"'
          return {
            ...parsed,
            text: [p.slice(0, pos), insertString, p.slice(pos)].join('')
          }
        }
        return parsed
      })
    }
  },
  methods: {
    cleanSplit (input, sep = /\n+/) {
      return input.split(sep).filter(p => !!p.trim())
    }
  }
}
</script>
